import { restGet, restPost } from "../../apiCommandsExecutor/rest";
import {
    CompanyCardRest,
    NewEventRest,
    PaymentProvidersDetailsRest,
} from "./restModels";

class GeneralRestService {
    static async getPaymentProviders(organizationBranchId: number) {
        return restGet<PaymentProvidersDetailsRest>(
            `/organization-branches/${organizationBranchId}/payment-providers`
        );
    }

    // Незаполненные реквизиты — обычный ответ с null, блок в меню просто не показывается.
    static async getLegalDetails(organizationBranchId: number) {
        return restGet<CompanyCardRest>(`/organization-branches/${organizationBranchId}/legal-details`);
    }

    static async addEvent(newEvent: NewEventRest) {
        return restPost<null>("/events", newEvent);
    }
}

export default GeneralRestService;
